import { PortalTelemetryScreen } from '../../../../../app/telemetry/portalTelemetryScreens';
import { portalAction, portalScreenContext } from '../../../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../../../app/telemetry/usePortalTelemetry';
import { Box, Button, Grid, Typography } from "@mui/material";
import pcsPlanFormModel from "../../../common/pcsPlanFormModel";
import { useAppDispatch, useAppSelector } from "../../../../../app/store/configureStore";
import { useEffect, useState } from "react";
import { ApiRequestStatus } from "../../../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../../../app/layout/LoadingComponent";
import { cancelReviewRequestAsync, searchReviewerByPersonIdAsync } from "../../../../../app/slices/pcsPdpSlice";
import { API_REQUEST_FULLFILLED, MESSAGE_PROCESSING_DETAILS, REVIEW_REQUEST_CANCELLED } from "../../../../../app/utils/constant";
import { PcsEnrolmentYear } from "../../../models/pcsEnrolmentYear";
import { useGetPcsEnrolmentYears } from "../../../../../app/customHooks/useGetPcsEnrolmentYears";
import { useParams } from "react-router-dom";
import { PdpStatusEnum } from "../../../models/pdpStatusEnum";
import { toast } from "react-toastify";
import { getPcsEnrolmentYearsAsync } from "../../../../../app/slices/pcsEnrolmentSlice";

export function ViewReviewer() {
    const { enrolmentYearId } = useParams<{ enrolmentYearId: string }>();

    const { Title, FirstName, Surname } = pcsPlanFormModel.formField;

    const { titles, pcsPdpStatuses } = useAppSelector(state => state.ReferenceData);
    const { reviewerDetails, searchReviewerByPersonIdStatus, cancelReviewRequestStatus } = useAppSelector(state => state.pcsPdp);
    const { enrolmentYears, enrolmentYearsStatus } = useAppSelector(state => state.pcsEnrolment);
    const { currentYear, currentYearStatus } = useAppSelector(state => state.pcs);

    const [enrolmentYear, setEnrolmentYear] = useState<PcsEnrolmentYear | undefined>();
    const [canCancelReviewRequest, setCanCancelReviewRequest] = useState<boolean>();

    const dispatch = useAppDispatch();

    useGetPcsEnrolmentYears();

    useEffect(() => {
        if (enrolmentYear && enrolmentYear !== null && reviewerDetails === null &&
            enrolmentYear?.pdpReviewerPersonId !== null) {
            dispatch(searchReviewerByPersonIdAsync(enrolmentYear?.pdpReviewerPersonId));
        }
    }, [enrolmentYear, reviewerDetails, dispatch]);

    useEffect(() => {
        if (enrolmentYears && enrolmentYears?.length > 0) {
            setEnrolmentYear(enrolmentYears?.find(x => x.enrolmentYearId === enrolmentYearId));
        }
    }, [enrolmentYears, enrolmentYearId]);

    useEffect(() => {
        if (enrolmentYears && enrolmentYears?.length > 0 && pcsPdpStatuses && currentYear) {
            const enrolmentYear = enrolmentYears?.find(x => x.enrolmentYearId === enrolmentYearId);
            const pcsPdpStatus = pcsPdpStatuses.find(x => x.id === enrolmentYear?.pcsPdpReviewStatusId);

            setCanCancelReviewRequest((pcsPdpStatus?.code === PdpStatusEnum.UnderReview
                || pcsPdpStatus?.code === PdpStatusEnum.ReviewRequestPending) && enrolmentYear?.year === currentYear);
        }
    }, [enrolmentYears, pcsPdpStatuses, enrolmentYearId, currentYear]);

    const cancelReviewRequest = () => {
        dispatch(cancelReviewRequestAsync(enrolmentYearId)).then((response: any) => {
            if (response.meta.requestStatus.toLowerCase() === API_REQUEST_FULLFILLED) {
                dispatch(getPcsEnrolmentYearsAsync()).then((response) => {
                    if (response.meta.requestStatus.toLowerCase() === API_REQUEST_FULLFILLED) {
                        toast.success(REVIEW_REQUEST_CANCELLED);
                    }
                });
            }
        });;
    }

    usePortalScreen(portalScreenContext(PortalTelemetryScreen.ViewReviewer), undefined, !((cancelReviewRequestStatus === ApiRequestStatus.Pending
        || searchReviewerByPersonIdStatus === ApiRequestStatus.Pending
        || enrolmentYearsStatus === ApiRequestStatus.Pending
        || currentYearStatus === ApiRequestStatus.Pending)));

        if (cancelReviewRequestStatus === ApiRequestStatus.Pending
        || searchReviewerByPersonIdStatus === ApiRequestStatus.Pending
        || enrolmentYearsStatus === ApiRequestStatus.Pending
        || currentYearStatus === ApiRequestStatus.Pending) {
        return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
    }

    return <Box sx={{ width: '100%' }}>
        <Grid container rowSpacing={4}>

            <Grid size={{ xs: 12 }}></Grid>
            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12 }}>
                <Typography variant='h6'><b>Reviewer details</b></Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 3 }}>
                <b>{Title.label.trim().endsWith("*") ?
                    Title.label.trim().substring(0, (Title.label.trim().length - 1)) :
                    Title.label}</b>
            </Grid>

            <Grid size={{ xs: 0.5 }}></Grid>

            <Grid size={{ xs: 12, sm: 8.5 }}>
                {titles?.find(x => x.id === reviewerDetails?.titleId)?.value}
            </Grid>

            <Grid size={{ xs: 12, sm: 3 }}>
                <b>{FirstName.label.trim().endsWith("*") ?
                    FirstName.label.trim().substring(0, (FirstName.label.trim().length - 1)) :
                    FirstName.label}</b>
            </Grid>

            <Grid size={{ xs: 0.5 }}></Grid>

            <Grid size={{ xs: 12, sm: 8.5 }}>
                {reviewerDetails?.firstnames}
            </Grid>

            <Grid size={{ xs: 12, sm: 3 }}>
                <b>{Surname.label.trim().endsWith("*") ?
                    Surname.label.trim().substring(0, (Surname.label.trim().length - 1)) :
                    Surname.label}</b>
            </Grid>

            <Grid size={{ xs: 0.5 }}></Grid>

            <Grid size={{ xs: 12, sm: 8.5 }}>
                {reviewerDetails?.surname}
            </Grid>

            <Grid size={{ xs: 12 }}></Grid>

            {canCancelReviewRequest === true &&
                <Grid size={{ xs: 12, sm: 12 }}>
                    <Button variant="contained" color="primary" onClick={portalAction(portalScreenContext(PortalTelemetryScreen.ViewReviewer), `${PortalTelemetryScreen.ViewReviewer}.onClick.cancelReviewRequest`, () => cancelReviewRequest())}>
                        Cancel review request
                    </Button>
                </Grid>
            }

        </Grid>
    </Box>
}
